import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CloudCustomer, ErmDevOpsApiClientService } from 'erm-sdk';
import * as _ from 'lodash';

@Component({
  standalone: false,
  templateUrl: './customer-details.component.html',
  styleUrls: ['./customer-details.component.scss']
})
export class CustomerDetailsComponent implements OnInit {

  isLoading = false;
  customerId: string;
  customer?: CloudCustomer;

  constructor(private ermDevOpsApiClient: ErmDevOpsApiClientService, route: ActivatedRoute) {
    this.customerId = route.snapshot.params['customerId'];
  }

  async ngOnInit(): Promise<void> {
    try {

      this.isLoading = true;

      // Get customer
      const getCustomerResponse = await this.ermDevOpsApiClient.getCloudCustomer(this.customerId);
      this.customer = getCustomerResponse.body?.cloudCustomer;

    } finally {
      this.isLoading = false;
    }
  }
}
